import { Component, OnInit } from '@angular/core';
import { Console } from '@angular/core/src/console';
import { NgbDateAdapter, NgbDateNativeAdapter, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import * as _ from 'lodash';
import { ToastrManager } from 'ng6-toastr-notifications';
import { from } from 'rxjs';
import { Customer } from 'src/app/models/customer';
import { Travel } from 'src/app/models/travel';
import { CustomerService } from 'src/app/services/customer.service';
import { TravelService } from 'src/app/services/travel.service';
import { UtilitiesService } from 'src/app/services/utilities.service';

@Component({
  selector: 'app-travel-routes',
  templateUrl: './travel-routes.component.html',
  styleUrls: ['./travel-routes.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class TravelRoutesComponent implements OnInit {

  loading: boolean = false;
  date1: Date = new Date();
  date2: Date = new Date();
  date3: Date = new Date('2023-12-26');
  travelAll = [];
  travels = [];
  travelRoutes = [];
  lines = [];
  linesAll = [];
  //travels: Travel[] = []; //Para guardar y mostrar los viajes obtenidos de la busqueda
  //Filtros
  idTravelSelected: number = 0;
  marketPrice: number;
  expand:boolean = false;
  //Mapeo
  customersSMaps: any[] = [];
  customerSAddressMaps: any[] = [];
  customersTMaps: any[] = [];
  customerTAddressMaps: any[] = [];
  //Origen
  customerSourceId: any = null;
  customerSourceName: any = null;
  customerSourceAddressId: number = 0;
  customerSourceAddressName: any = null;
  //Destino
  customerTargetId: any = null;
  customerTargetName: any = null;
  customerTargetAddressId: number = 0;
  customerTargetAddressName: any = null;
  //Socios
  customers:Customer[] = [];
  customer: Customer;

  constructor(private travelServ: TravelService, private utl: UtilitiesService, private toastr: ToastrManager, private modal:NgbModal, private customerServ: CustomerService) { }

  ngOnInit() {
    this.getCustomers();
  }

  getCustomers(){
    this.loading = true;
    this.customerServ.getCustomers().then(customers => {
      this.customers = customers;
      this.setValueCustomers();
      this.loading = false;
    });
  }

  search(){
    this.loading = true;
    this.travelServ.getTravelRoutesById(this.customerSourceId, this.customerSourceAddressId, this.customerTargetId, this.customerTargetAddressId).then(response => {
      this.travelRoutes = response;
      this.loading = false;
    }, error => {
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
      this.loading = false;
    });
  }

  updateMarketPrice(){
    this.loading = true;
    this.travelServ.updateMarketPriceByDirections(this.marketPrice, this.customerSourceId, this.customerSourceAddressId, this.customerTargetId, this.customerTargetAddressId).then(response => {
      this.search();
      this.setValueCustomers();
      this.loading = false;
      this.modal.dismissAll();
      this.toastr.successToastr('Se actualizó el precio de mercado correctamente.', '', {enableHTML: true});
    }, error => {
      this.loading = false;
      this.toastr.errorToastr(this.utl.formatMessages(error), '', {enableHTML: true});
    });
  }

  openM(m, id:number) {
    this.loading = true;
    this.idTravelSelected = id;
    this.marketPrice = 0;
    this.modal.open(m, { size: 'lg' });
    this.loading = false;
  }

  setValueCustomers(){
    this.customersSMaps = []; //Socios Origen
    this.customersTMaps = []; //Direcciones Origen
    this.customerSAddressMaps = []; //Socios Destino
    this.customerTAddressMaps = []; //Direcciones Destino
    this.customers.forEach(c => this.customersSMaps.push({id: c.id, text: c.name}));
    this.customersTMaps = [...this.customersSMaps];
    //Origen
    this.customerSourceId = this.customersSMaps[0].id;
    this.customerSourceName = this.customersSMaps[0].text;
    //Destino
    this.customerTargetId = this.customersTMaps[0].id;
    this.customerTargetName = this.customersTMaps[0].text;
    //Direcciones inicio cliente default
    this.customers.find(c => c.id == this.customerSourceId).directions.forEach(ac => this.customerSAddressMaps.push({id: ac.id, text: ac.name}));
    this.customers.find(c => c.id == this.customerTargetId).directions.forEach(ac => this.customerTAddressMaps.push({id: ac.id, text: ac.name}));
    //Origen
    this.customerSourceAddressId = this.customerSAddressMaps[0].id;
    this.customerSourceAddressName = this.customerSAddressMaps[0].text;
    //Destino
    this.customerTargetAddressId = this.customerTAddressMaps[0].id;
    this.customerTargetAddressName = this.customerTAddressMaps[0].text;
  }

  changeCustomerS(event){
    if(event['value'] != null){
      this.customer = this.customers.find(c => c.id == event['value']);
      this.customerSourceId = this.customer.id;
      this.customerSourceName = this.customer.name;
      this.customerSAddressMaps = [];
      if(this.customer.directions.length > 0){
        this.customer.directions.forEach(a => this.customerSAddressMaps.push({id: a.id, text: a.name}));
        this.customerSourceAddressId = this.customerSAddressMaps[0].id;
        this.customerSourceAddressName = this.customerSAddressMaps[0].text;
      }
    }
  }

  changeAddressS(event){
    if(event['value'] != null){
      this.customerSourceAddressId = this.customerSAddressMaps.find(a => a.id == event['value']).id;
      this.customerSourceAddressName = this.customerSAddressMaps.find(a => a.id == event['value']).text;
    }
  }

  changeCustomerT(event){
    if(event['value'] != null){
      this.customer = this.customers.find(c => c.id == event['value']);
      this.customerTargetId = this.customer.id;
      this.customerTargetName = this.customer.name;
      this.customerTAddressMaps = [];
      //Validamos que tenga direcciones, ejemplo cliente HI-FOS no tiene 
      if(this.customer.directions.length > 0){
        this.customer.directions.forEach(a => this.customerTAddressMaps.push({id: a.id, text: a.name}));
        this.customerTargetAddressId = this.customerTAddressMaps[0].id;
        this.customerTargetAddressName = this.customerTAddressMaps[0].text;
      }
    }
  }

  changeAddressT(event){
    if(event['value'] != null){
      this.customerTargetAddressId = this.customerTAddressMaps.find(a => a.id == event['value']).id;
      this.customerTargetAddressName = this.customerTAddressMaps.find(a => a.id == event['value']).text;
    }
  }
}
